import { render, staticRenderFns } from "./ExportDispatch.vue?vue&type=template&id=35cb6a74&scoped=true"
import script from "./ExportDispatch.vue?vue&type=script&lang=js"
export * from "./ExportDispatch.vue?vue&type=script&lang=js"
import style0 from "./ExportDispatch.vue?vue&type=style&index=0&id=35cb6a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cb6a74",
  null
  
)

export default component.exports